import { useEffect, useState } from 'react';

/** Follows a CSS media query. Without matchMedia (tests) it answers `fallback`. */
export function useMediaQuery(query: string, fallback = true): boolean {
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : fallback);
  const [on, setOn] = useState(get);
  useEffect(() => {
    if (!window.matchMedia) return;
    const m = window.matchMedia(query);
    const h = () => setOn(m.matches);
    h();
    m.addEventListener('change', h);
    return () => m.removeEventListener('change', h);
  }, [query]);
  return on;
}
